import * as React from "react";
import { marketColumnsDisplay } from "../../../../../constants";
import { ContainerQuery } from "react-container-query";
import { SecondaryHeading, HeadingTitle } from "../../../components";
import { RenderMarketNames } from "../RenderMarketNames";
export class RenderCustomHeading extends React.PureComponent {
    renderCustomHeading(params) {
        return React.createElement(SecondaryHeading, { key: `subheading-${this.props.id}`, componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: "", eventsCount: "" }),
            React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params }));
    }
    render() {
        return (React.createElement(ContainerQuery, { query: marketColumnsDisplay }, (params) => this.renderCustomHeading(params)));
    }
}
//# sourceMappingURL=RenderCustomHeading.js.map